import React, { useContext } from 'react';

import { Field, Image, ImageField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { ComponentProps } from 'lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import ArrowSvg from 'public/icons/ArrowRight.svg';

import styles from './Instructions.module.css';

type InstructionsProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		items?: ExtendedItem &
			[
				{
					fields: {
						Text: Field<string>;
						Image: ImageField;
					};
				}
			];
	};
};

export default withDatasourceCheck()<InstructionsProps>(Instructions);

function Instructions(props: InstructionsProps): JSX.Element {
	const RcnUser = useContext(RcnUserContext);

	// TODO: Remove when we can use favourites-based personalisation to show/hide
	if (RcnUser.userFavourites?.length) {
		return <></>;
	}

	return (
		<section className="maxWidth padX">
			<Text tag="h3" className="cen padY" field={props.fields.Title} />
			<div className={`${styles.grid}`}>
				{props.fields.items &&
					props.fields.items.map((step, index) => (
						<React.Fragment key={`${props.rendering.dataSource}-${index}`}>
							{index !== 0 && (
								<aside className={styles.step}>
									<ArrowSvg className={styles.arrow} />
								</aside>
							)}

							<article className={styles.step}>
								<Text tag="p" field={step.fields.Text} />

								<p>
									<EditorHelp text="Image maxWidth 400px" />
									<Image field={step.fields.Image} loading="lazy" height={200} width={300} />
								</p>
							</article>
						</React.Fragment>
					))}
			</div>
		</section>
	);
}
